module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori@2x-9dd48d3ed6955096c3cd68074c73e8a5.webp";